import { BaseButton } from "./BaseButton-react"
import { asyncButtonDefaultProps as defaultProps } from "./config"
import { getAsyncButtonClasses } from "./style-react"
import type { ButtonProps } from "./types"
import { LazySpinner } from "../../DataDisplay/Spinner/LazySpinner"

/**
 * **Props**:
 * - `text`: string
 * - `size`: "small" | "medium" | "large"
 * - `variant`: "primary" | "secondary" | "tertiary" | "tertiary/compact" | "destructive"
 * - `disabled`: boolean — *prevents user interactions*
 * - `loading`: boolean — *implicitly sets `disabled`*
 * - `onPress`: function
 *
 * See also: {@link ButtonProps}
 */
export const Button = (customProps: ButtonProps) => {
  const { children, loading, disabled, ...props } = { ...defaultProps, ...customProps }

  const c = getAsyncButtonClasses()

  return (
    <BaseButton text={children} disabled={disabled || loading} contentInvisible={loading} {...props}>
      {loading && (
        <div className={c.spinner}>
          <LazySpinner size="auto" />
        </div>
      )}
    </BaseButton>
  )
}
